// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__x8aWW","content":"LoadingAlert_content__nXS2k"};